import { render, staticRenderFns } from "./AccordionItemHeader.vue?vue&type=template&id=21646e9b&scoped=true&"
import script from "./AccordionItemHeader.vue?vue&type=script&lang=js&"
export * from "./AccordionItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItemHeader.vue?vue&type=style&index=0&id=21646e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21646e9b",
  null
  
)

export default component.exports